import { Button, Col, ConfigProvider, Radio, Row } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import Table, { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import {
  getLabList,
  getLastVersion,
  getParsicUser,
  getVersionHistory,
  getVersionRelease
} from '../../../api/api';
import Spinner from "../../../components/_common/Spinner";
import { errorNotify, errorNotifyByErrorObject } from "../../../services/toast.notification";
import CustomSelect from "../../../components/_common/CustomSelect";

const VersionManagement = () => {

  const columns: ColumnsType<any> = [
    { title: 'آزمایشگاه', dataIndex: 'Str_LabPersianName' },
    { title: 'کاربر', dataIndex: 'Str_FullName' },
    { title: 'ورژن', dataIndex: 'Str_VersionTo' },
    { title: 'توضیحات', dataIndex: 'Str_Description' },
  ];

  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [labList, setLabList] = useState<any[]>([]);
  const [versionList, setVersionList] = useState<any[]>([]);
  const [parsicUserList, setParsicUserList] = useState<any[]>([]);

  const [labId, setLabId] = useState<string | undefined>(undefined);
  const [versionId, setVersionId] = useState<string | undefined>(undefined);
  const [userId, setUserId] = useState<string | undefined>(undefined);

  /* ======================= FILTER LOGIC ======================= */

  const applyFilters = (
    lab = labId,
    user = userId,
    version = versionId
  ) => {
    let result = [...data];

    if (lab !== undefined) {
      result = result.filter(d => d.Frk_LabID == lab);
    }

    if (user !== undefined) {
      result = result.filter(d => d.Frk_ParsicUserID == user);
    }

    if (version !== undefined) {
      result = result.filter(d => d.Str_VersionTo == version);
    }

    setFilteredData(result);
  };

  /* ======================= API CALLS ======================= */

  const _getlastVersion = () => {
    setIsLoading(true);

    getLastVersion()
      .then((res: any) => {

        setData(res.data);
        setFilteredData(res.data);

        if (res.data.length > 0) {
          _getVersionRelease();
        } else {
          setIsLoading(false);
        }
      })
      .catch(err => {
        setIsLoading(false);
        errorNotify(err.response?.data?.errorMessage);
      });
  };

  const _getVersionRelease = () => {
    getVersionRelease(2)
      .then(res => {
        setVersionList(res.data);
        _getParsicUser();
      })
      .catch(err => {
        setIsLoading(false);
        errorNotify(err.response?.data?.errorMessage);
      });
  };

  const _getParsicUser = () => {
    getParsicUser()
      .then(res => {
        setParsicUserList(res.data.data);
        _getLabList();
      })
      .catch(err => {
        setIsLoading(false);
        errorNotifyByErrorObject(err);
      });
  };

  const _getLabList = () => {
    getLabList()
      .then(res => {
        setLabList(res.data.data);
        setIsLoading(false);
      })
      .catch(err => {
        setIsLoading(false);
        errorNotify(err.response?.data?.errorMessage);
      });
  };

  /* ======================= HANDLERS ======================= */

  const labChange = (lab: any) => {
    setLabId(lab.target.value);
    applyFilters(lab.target.value, userId, versionId);
  };

  const userChange = (user: any) => {
    setUserId(user.target.value);
    applyFilters(labId, user.target.value, versionId);
  };

  const versionChange = (version: any) => {
    setVersionId(version.target.value);
    applyFilters(labId, userId, version.target.value);
  };

  const resetFilters = () => {
    setLabId(undefined);
    setUserId(undefined);
    setVersionId(undefined);
    setFilteredData(data);
  };

  useEffect(() => {
    _getlastVersion()
  },[])

  /* ======================= RENDER ======================= */

  return (
    <div className="tab-content-padding">
      {isLoading && <Spinner />}

      {!isLoading && (
        <>
          {data.length > 0 && (
            <>
              <Row gutter={16}>
                <Col lg={8} sm={24}>
                  <CustomSelect
                    placeholder="آزمایشگاه"
                    itemList={labList}
                    value={labId || ""}
                    onChange={labChange}
                    valueObjectField="prk_AndriodLab_AutoID"
                    displayObjectField="str_LabPersianName"

                  />
                </Col>

                <Col lg={8} sm={24}>
                  <CustomSelect
                    placeholder="ورژن"
                    itemList={versionList}
                    value={versionId || ""}
                    onChange={versionChange}
                    valueObjectField="str_VersionNumber"
                    displayObjectField="str_VersionNumber"
                  />
                </Col>

                <Col lg={8} sm={24}>
                  <CustomSelect
                    placeholder="کاربر"
                    itemList={parsicUserList}
                    value={userId || ""}
                    onChange={userChange}
                    valueObjectField="prk_ParsicUser_AutoID"
                    displayObjectField="str_FullName"
                  />
                </Col>
                <Col lg={24} style={{ textAlign: 'left' }}>
                  <Button danger onClick={resetFilters}>
                    حذف فیلترها
                  </Button>
                </Col>
              </Row>

              <Table
                rowKey="Prk_LabVersionLog_AutoID"
                scroll={{ x: 1500 }}
                dataSource={filteredData}
                columns={columns}
              />
            </>
          )}

          {filteredData.length === 0 && (
            <p className="empty-data">داده‌ای برای نمایش موجود نیست.</p>
          )}
        </>
      )}
    </div>
  );
};

export default VersionManagement;
